import {
  AUTH_TOKEN_KEY,
  GET_USER_POINT,
  GET_POINT_TIER,
  GET_POINT_HISTORY,
  GET_USER_VOUCHER,
  GET_USER_RAFFLE,
  GET_VOUCHER_HISTORY,
  GET_RAFFLE_HISTORY
} from '../constants/';
import fetch from '../utils/Api';

export const getUserPoint = () => ({
  type: GET_USER_POINT,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get("users/points/status")
    .then(res => res.data)
})

export const getPointTier = () => ({
  type: GET_POINT_TIER,
  payload: fetch()
    .get("points")
    .then(res => res.data)
})

export const getPointHistory = (payload) => ({
  type: GET_POINT_HISTORY,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get("users/points", { params: payload })
    .then(res => res.data)
})

export const getUserVoucher = (payload) => ({
  type: GET_USER_VOUCHER,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get("user_vouchers", { params: payload })
    .then(res => res.data)
})

export const getUserRaffle = (payload) => ({
  type: GET_USER_RAFFLE,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get("raffles/owned", { params: payload })
    .then(res => res.data)
})

export const getVoucherHistory = (payload) => ({
  type: GET_VOUCHER_HISTORY,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get("user_vouchers", { params: payload })
    .then(res => res.data)
})

export const getRaffleHistory = (payload) => ({
  type: GET_RAFFLE_HISTORY,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get("raffles/owned", { params: payload })
    .then(res => res.data)
})